import React, { useContext } from 'react';
import styled, { ThemeContext } from 'styled-components';

import device from '../utils/device';
import PaymentBox from './PaymentBox';
import Banner from './Banner';
import CourseOverview from './CourseOverview';
import Bonuses from './Bonuses';
import { Button } from './Button';

const Container = styled.section`
  @media ${device.desktop} {
    margin-top: 0rem;
  }
`;

const WidthContainer = styled.section`
  p,
    li {
    font-size: 17px;
  }
  p {
    line-height: 1.8rem;
  }
  margin: 2rem auto;

  @media ${device.desktop} {
    width: 60vw;
  }
`

const Row = styled.div`
  text-align: left;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 1rem;
`;

const CenterDiv = styled.div`
 text-align: center;
 margin: 1rem 0;
`;

const Column = styled.div`
  flex-basis: 100%;
  @media ${device.desktop} {
    flex-basis: 50%;
  }
`;

const ColumnInner = styled.div`
  padding: 0 1rem;
`;

const Title = styled.h2`
  color: ${({ theme }) => theme.colors.textDark};
  font-weight: 700;
  font-size: 1.5rem;
`;

const CenterTitle = styled.h1`
  color: ${({ theme }) => theme.colors.textDark};
  font-weight: 700;
  font-size: 2rem;
  margin: 3rem 0;
  text-align: center;
`;

const PaymentRow = styled.div`
  margin: 1.6rem;

  @media ${device.desktop} {
    display: flex;
    margin: 0 10vw;
    padding: 4rem 0;
    justify-content: space-evenly;
  }
`;

const PositionedButton = styled(Button)`
  margin: 1rem auto 0;
`;

const Payment = () => (
  <PaymentRow id="payment-options">
    <PaymentBox
      title="Join now"
      subTitle=""
      discount="50"
      benefit="Lifetime access"
      wasUsd={397}
      priceUsd={197}
      priceEuro={192}
      priceGbp={162}
      codeUsd="4195971"
      codeEuro="4195974"
      codeGbp="4195972"
      best
    />
    {/* <PaymentBox
      title="Installments"
      subTitle="3 payments of"
      discount="20"
      benefit="Lifetime access after 3 months"
      priceUsd={115}
      priceEuro={97}
      priceGbp={83}
      codeUsd="3364261"
      codeEuro="3364264"
      codeGbp="3364263"
    /> */}
  </PaymentRow>
);

const SalesSection = () => {
  const theme = useContext(ThemeContext);

  return (
    <Container>
      <CourseOverview />

      {/* <PracticalDetails /> */}

      <Banner>
        <h1>Who should attend?</h1>
        <div>The unique and in-depth program is open to all.</div>
      </Banner>

      <WidthContainer>
        <Row>
          <Column>
            <ColumnInner>
              <CenterDiv>
                <Title>The Trauma &amp; Awakening Program is for you if &hellip;</Title>
              </CenterDiv>
              <ul>
                <li>You have noticed trauma showing up on your spiritual path</li>
                <li>You are interested about the potential for using trauma as a gateway to spiritual experiences&nbsp;</li>
                <li>You&rsquo;d like to shift from &ldquo;dealing with&rdquo; pain to integrating it into your spiritual path</li>
                <li>You feel called to spiritual exploration as a means of healing but don&rsquo;t know where to start</li>
                <li>You&rsquo;d like to develop a place of inner calm despite any external challenges in your life or the world at large</li>
              </ul>
            </ColumnInner>
          </Column>
          <Column>
            <ColumnInner>
              <CenterDiv>
                <Title>Here&rsquo;s what&rsquo;s included in the 12-hour Trauma &amp; Awakening Program:</Title>
              </CenterDiv>
              <ul>
                <li>4 x 3-hour in-depth training sessions with Gabor and Hameed that include teachings, guided meditations, and practical exercises and inquiries</li>
                <li>Lifetime access to recordings to watch at your leisure with the option of closed captioning</li>
                <li>Transcripts of all sessions (including in French and German)</li>
                <li>Private Facebook group (optional)</li>
              </ul>
            </ColumnInner>
          </Column>
        </Row>
        <Row>
          <PositionedButton
            to="#payment-options"
            variant="solid"
            size="SM"
            color={theme.colors.actionPrimary}
          >
            Click here to register
          </PositionedButton>
        </Row>
      </WidthContainer>

      <Bonuses />

      <WidthContainer>
        <CenterTitle>
          A quick overview of what’s covered in each of the 4 session:
        </CenterTitle>

        <Row>
          <Column>
            <ColumnInner>
              <Title><sup>Session #1</sup> <br /> with Hameed Ali</Title>
              <ul>
                <li>Grounding meditation</li>
                <li>The ego world and developing an ego structure</li>
                <li>Being present vs presence</li>
                <li>What cultivates deeper presence</li>
                <li>Understanding the enlightenment drive</li>
                <li>The impact of defense mechanisms</li>
                <li>How to turn towards our suffering</li>
                <li>The practice of inquiry in the Diamond Approach</li>
                <li>Exercise: exploring how we respond to our emotional difficulties</li>
              </ul>
            </ColumnInner>
          </Column>
          <Column>
            <ColumnInner>
              <Title><sup>Session #2</sup> <br /> with Hameed Ali and Dr Gabor Maté</Title>
              <ul>
                <li>Guided meditation</li>
                <li>Trauma as a sensitive wound and a numb scar</li>
                <li>How trauma impacts brain development</li>
                <li>The importance of basic trust</li>
                <li>4 character traits that can lead to health conditions</li>
                <li>Why boundaries matter</li>
                <li>Exercise: journaling to explore capacity for boundaries</li>
                <li>Theory of Holes</li>
                <li>How is psychotherapy different from spiritual work?</li>
              </ul>
            </ColumnInner>
          </Column>
        </Row>
        <Row>
          <Column>
            <ColumnInner>
              <Title><sup>Session #3</sup> <br /> with Dr Gabor Maté</Title>
              <ul>
                <li>Why developing a healthy will matters</li>
                <li>Boundaries and physical health</li>
                <li>Cultivating our capacity for &ldquo;Yes&rdquo; and &ldquo;No&rdquo;</li>
                <li>Gabor&rsquo;s &ldquo;Happy Childhood Challenge&rdquo;</li>
                <li>Gabor&rsquo;s practice of Compassionate Inquiry</li>
                <li>Understanding our attachment needs and vulnerability</li>
                <li>Strategies to disengage from our inner critic</li>
                <li>The 5 levels of compassion</li>
                <li>How to shift out of identification with limiting beliefs</li>
              </ul>

            </ColumnInner>
          </Column>
          <Column>
            <ColumnInner>
              <Title><sup>Session #4</sup> <br /> with Dr Gabor Maté and Hameed Ali</Title>
              <ul>
                <li>Guided meditation</li>
                <li>How tension patterns can obstruct spiritual access</li>
                <li>Practical to help open inner blockages</li>
                <li>How traumatic experiences can open up spiritual dimensions</li>
                <li>When specialized trauma therapy is needed</li>
                <li>The power of presence to hold us</li>
                <li>Egoic vs. essential orientation to pain</li>
                <li>The critical shift from victimhood to agency</li>
                <li>How to reconnect with our agency when we are triggered</li>
              </ul>
            </ColumnInner>
          </Column>
        </Row>

        <CenterTitle>
          The Trauma & Awakening Program comes with LIFETIME ACCESS to all of the content and bonuses PLUS a 14-day money-back guarantee.
        </CenterTitle>
      </WidthContainer>

      <Payment />

      <Banner>
        <h1>Have questions?</h1>
        <PositionedButton
          color="white"
          size="SM"
          onClick={() => {
            window.zE('webWidget', 'open');
          }}
        >
          If you have any questions at all, please click here to access our
          support centre
        </PositionedButton>
      </Banner>
    </Container>
  );
};

export default SalesSection;
